export const notFound = {
  path: '/:pathMatch(.*)',
  name: 'notFound',
  meta: {
    title: '404'
  },
  component: () => import('@/views/system/error/404.vue')
  //redirect: defaultRoutePath
};
